import { Dialog } from './dialog';
import { Button } from "primereact/button";

type DeleteEntityConfirmDialogProps = {
  visible: boolean;
  onCancel: () => void;
  onConfirm: () => Promise<void>;
  entityType: string;
  entityName: string;
};

export function DeleteEntityConfirmDialog({
  visible,
  onCancel,
  onConfirm,
  entityType,
  entityName
}: DeleteEntityConfirmDialogProps) {
  return (
    <Dialog header={`Confirm Deleting ${entityType}`} visible={visible} onHide={onCancel} style={{ width: "400px" }} modal >
      <p className="m-0" style={{ lineHeight: 1.5 }}>
        Are you sure you want to delete{" "}
        <span className="font-bold">{entityName}</span>?
        <br />
        This action cannot be undone.
      </p>

      <div className="flex justify-content-end gap-2 mt-4">
        <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={onCancel} />
        <Button label="Delete" icon="pi pi-trash" severity="danger" onClick={onConfirm} />
      </div>
    </Dialog>
  );
}